import {
  Button, Flex, Space, Typography
} from "antd";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Background from "../Background";
import { appRoutes } from "../../constants/routes";
import useCurrentUser from "../../hooks/useCurrentUser";
import Onboarding from "./onboarding";

const { Title } = Typography;

const PatientDashboard = () => {
  const { t } = useTranslation();
  const { data } = useCurrentUser();
  const { isPatientApproved } = useCurrentUser();

  return (
    <>
      <Background step={5}/>
      <Flex vertical align="center" justify="center" style={{ zIndex: 10, paddingTop: "15vh" }}>
        <Space size={0} direction="vertical" style={{ marginBottom: "7vh" }}>
          <Title level={2}>
            {t("global.labels.welcome")}, {data ? data.name : null}
          </Title>
          {!isPatientApproved ? null : (
            <Link to={appRoutes.appointments}>
              <Button type="primary" block>
                {t("dashboardPage.goToAppointments")}
              </Button>
            </Link>
          )}
        </Space>
        <Onboarding />
      </Flex>
    </>
  );
};

export default PatientDashboard;
